import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';


@Injectable({
  providedIn: 'root'
})
export class CustomService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = '';
    this.endpoint_path = '';
    this.httpClient = http;
  }

  public setApiUrl(domainUrl: string, endpointPath: string) {
    this.endpoint_path = endpointPath;
    this.apiUrl = domainUrl + endpointPath;
  }
}
